(function () {
  'use strict';

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function getText(el) {
    return el ? (el.textContent || '').trim() : '';
  }

  function init() {
    const bar = document.querySelector('[data-product-sticky-bar]');
    if (!bar) return;

    const mq = window.matchMedia('(min-width: 990px)');
    let initialized = false;

    function initDesktop() {
      if (initialized) return;
      if (!mq.matches) return;
      initialized = true;

      if (bar.parentElement !== document.body) {
        document.body.appendChild(bar);
      }

      const sectionId = bar.getAttribute('data-section-id');
      const variantRootId = bar.getAttribute('data-variant-root-id');

      const variantRoot =
        (variantRootId && document.getElementById(variantRootId)) ||
        (sectionId && document.querySelector(`#variant-radios-${cssEscape(sectionId)}`)) ||
        document.querySelector('variant-radios');

      const productInfoBuy =
        document.querySelector('.product-info-buy-btn-normal') || document.querySelector('.product-info-buy-btn');
      let mainAtcButton =
        (productInfoBuy &&
          productInfoBuy.querySelector('.product-form__buttons button[type="submit"], product-form [type="submit"]')) ||
        document.querySelector('.product-form__buttons button[type="submit"], product-form [type="submit"]');

      const priceSource = sectionId
        ? document.getElementById(`price-${sectionId}`)
        : document.querySelector('[id^="price-"]');
      const priceTarget = bar.querySelector('[data-sticky-price]');

      const sizeOptionName = bar.getAttribute('data-size-option-name') || '';
      const colorOptionName = bar.getAttribute('data-color-option-name') || '';

      const sizeSelect = bar.querySelector('[data-sticky-size-select]');
      const colorButtons = Array.from(bar.querySelectorAll('[data-sticky-color-value]'));
      const stickyAtc = bar.querySelector('[data-sticky-atc]');
      const stickyTooltip = bar.querySelector('[data-sticky-tooltip]');

      let observer = null;
      let priceObserver = null;

      function show() {
        if (!bar.hasAttribute('hidden')) {
          bar.classList.add('is-visible');
          requestAnimationFrame(checkFooterCollision);
          return;
        }
        bar.removeAttribute('hidden');
        requestAnimationFrame(() => {
          bar.classList.add('is-visible');
          checkFooterCollision();
        });
      }

      function hide() {
        if (bar.hasAttribute('hidden')) return;
        bar.classList.remove('is-visible');
        const onEnd = (e) => {
          if (e.propertyName !== 'opacity') return;
          bar.setAttribute('hidden', '');
          bar.removeEventListener('transitionend', onEnd);
        };
        bar.addEventListener('transitionend', onEnd);
        window.setTimeout(() => {
          if (!bar.classList.contains('is-visible')) bar.setAttribute('hidden', '');
        }, 400);
      }

      function syncPrice() {
        if (!priceTarget) return;
        if (priceSource) priceTarget.innerHTML = priceSource.innerHTML;
      }

      function checkSizeSelected() {
        // Si no hay selector de talla, siempre retornar true (no requiere talla)
        if (!sizeSelect || !sizeOptionName) return true;

        // Verificar si hay una talla seleccionada en los radios reales
        if (variantRoot) {
          const checked = variantRoot.querySelector(`input.variant-input[name="${cssEscape(sizeOptionName)}"]:checked`);
          return checked !== null && checked.value !== '';
        }

        // Fallback: verificar el valor del select
        return sizeSelect.value !== '' && sizeSelect.value !== null;
      }

      function syncAtcState() {
        if (!stickyAtc) return;

        // Verificar primero si necesita talla y no está seleccionada
        const hasSizeSelected = checkSizeSelected();

        if (!hasSizeSelected && sizeOptionName) {
          // Bloquear botón y mostrar tooltip si no hay talla seleccionada
          stickyAtc.setAttribute('disabled', 'disabled');
          stickyAtc.setAttribute('aria-disabled', 'true');
          if (stickyTooltip) {
            stickyTooltip.style.display = 'block';
          }
          return;
        }

        // Ocultar tooltip si hay talla seleccionada
        if (stickyTooltip) {
          stickyTooltip.style.display = 'none';
        }

        // Re-buscar el botón principal por si cambió después de actualizar variante
        const currentMainButton =
          (productInfoBuy &&
            productInfoBuy.querySelector(
              '.product-form__buttons button[type="submit"], product-form [type="submit"]'
            )) ||
          document.querySelector('.product-form__buttons button[type="submit"], product-form [type="submit"]');

        if (!currentMainButton) {
          stickyAtc.removeAttribute('disabled');
          stickyAtc.removeAttribute('aria-disabled');
          return;
        }

        // Verificar si está disabled PERO también verificar si está en estado "loading"
        // Si está loading, esperamos un poco antes de sincronizar
        const isDisabled =
          currentMainButton.hasAttribute('disabled') || currentMainButton.getAttribute('aria-disabled') === 'true';

        const isLoading = currentMainButton.classList.contains('loading');

        // Si está loading, esperar un poco antes de sincronizar
        if (isLoading) {
          setTimeout(() => syncAtcState(), 100);
          return;
        }

        stickyAtc.toggleAttribute('disabled', isDisabled);
        if (isDisabled) {
          stickyAtc.setAttribute('aria-disabled', 'true');
        } else {
          stickyAtc.removeAttribute('aria-disabled');
        }

        const mainLabel =
          getText(currentMainButton.querySelector('span:not(.sold-out-message)')) ||
          getText(currentMainButton.querySelector('span')) ||
          getText(currentMainButton);

        if (mainLabel) stickyAtc.textContent = mainLabel;
      }

      function clickVariantInput(optionName, value) {
        if (!variantRoot || !optionName) return false;
        const sel = `input.variant-input[name="${cssEscape(optionName)}"][value="${cssEscape(value)}"]`;
        const input = variantRoot.querySelector(sel);
        if (!input) return false;
        input.click();
        return true;
      }

      function syncSelectionsFromPdp() {
        if (!variantRoot) return;

        if (sizeSelect && sizeOptionName) {
          const checked = variantRoot.querySelector(`input.variant-input[name="${cssEscape(sizeOptionName)}"]:checked`);
          if (checked && checked.value) {
            sizeSelect.value = checked.value;
          }
        }

        if (colorButtons.length && colorOptionName) {
          const checked = variantRoot.querySelector(
            `input.variant-input[name="${cssEscape(colorOptionName)}"]:checked`
          );
          const checkedValue = checked ? checked.value : null;
          colorButtons.forEach((btn) => {
            const v = btn.getAttribute('data-sticky-color-value');
            const active = checkedValue && v === checkedValue;
            btn.classList.toggle('is-active', !!active);
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        }
      }

      function bindUi() {
        if (sizeSelect && sizeOptionName) {
          sizeSelect.addEventListener('change', (e) => {
            const v = e.target.value;
            clickVariantInput(sizeOptionName, v);
            // Verificar estado después de cambiar talla
            setTimeout(() => syncAtcState(), 100);
          });
        }

        if (colorButtons.length && colorOptionName) {
          colorButtons.forEach((btn) => {
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              const v = btn.getAttribute('data-sticky-color-value');
              if (!v) return;
              clickVariantInput(colorOptionName, v);
            });
          });
        }

        // Manejar productos relacionados de color (enlaces)
        const relatedColorLinks = Array.from(bar.querySelectorAll('[data-sticky-related-product-id]'));
        if (relatedColorLinks.length > 0) {
          relatedColorLinks.forEach((link) => {
            link.addEventListener('click', (e) => {
              // Permitir que el enlace navegue normalmente
              // No prevenir el comportamiento por defecto
            });
          });
        }

        if (stickyAtc) {
          stickyAtc.addEventListener('click', (e) => {
            e.preventDefault();

            // Si no hay talla seleccionada, no hacer nada
            if (!checkSizeSelected() && sizeOptionName) {
              return;
            }

            if (!mainAtcButton) {
              mainAtcButton =
                (productInfoBuy &&
                  productInfoBuy.querySelector(
                    '.product-form__buttons button[type="submit"], product-form [type="submit"]'
                  )) ||
                document.querySelector('.product-form__buttons button[type="submit"], product-form [type="submit"]');
            }
            if (!mainAtcButton) return;
            mainAtcButton.click();
          });
        }

        if (variantRoot) {
          variantRoot.addEventListener('change', (e) => {
            const target = e.target;
            if (!(target instanceof HTMLInputElement)) return;
            if (!target.classList.contains('variant-input')) return;
            syncSelectionsFromPdp();
            syncPrice();
            // Delay para esperar a que el tema actualice el estado del botón principal
            setTimeout(() => syncAtcState(), 150);
          });
        }

        document.addEventListener('variant:change', () => {
          syncSelectionsFromPdp();
          syncPrice();
          // Delay para esperar a que el tema actualice el estado del botón principal
          setTimeout(() => syncAtcState(), 150);
        });

        // Observar cambios en el botón principal para sincronizar automáticamente
        if (mainAtcButton) {
          const atcObserver = new MutationObserver(() => {
            syncAtcState();
          });
          atcObserver.observe(mainAtcButton, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class'],
            childList: true,
            subtree: true,
          });
        }
      }

      function checkFooterCollision() {
        const footer = document.querySelector('footer');
        const localizationSection = footer ? footer.querySelector('.footer__localization') : null;

        if (!footer || !bar.classList.contains('is-visible')) {
          bar.classList.remove('is-fading');
          if (bar.classList.contains('is-visible')) {
            bar.style.opacity = '';
          }
          return;
        }

        // Obtener la posición del footer y del selector de idioma
        const footerRect = footer.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // Calcular la altura del sticky bar
        const barHeight = bar.offsetHeight || 80;

        // Verificar si el usuario ha llegado al final del scroll (tope hacia abajo)
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollBottom = scrollTop + windowHeight;

        // Solo desvanecer cuando realmente está en el tope (final del scroll)
        // Con un pequeño margen para detectar cuando está en el final
        const isAtBottom = scrollBottom >= documentHeight - 10; // 10px de margen para detectar el tope

        // Si no está en el tope, no desvanecer
        if (!isAtBottom) {
          bar.classList.remove('is-fading');
          bar.style.opacity = '';
          bar.style.pointerEvents = '';
          return;
        }

        // El sticky bar está en la parte inferior (bottom: 0)
        // Zona del sticky bar: desde (windowHeight - barHeight) hasta windowHeight
        const stickyBarTop = windowHeight - barHeight;
        const stickyBarBottom = windowHeight;

        // Si está en el tope, verificar si el selector de idioma está en la zona del sticky bar
        let shouldHide = false;

        if (localizationSection) {
          // Obtener la posición del selector de idioma
          const localizationRect = localizationSection.getBoundingClientRect();
          const localizationBottom = localizationRect.bottom;
          const localizationTop = localizationRect.top;

          // Si el selector de idioma está dentro o cerca de la zona del sticky bar
          // Verificar si hay cualquier superposición
          if (localizationBottom >= stickyBarTop && localizationTop <= stickyBarBottom) {
            // Si hay superposición, ocultar completamente
            shouldHide = true;
          }
        } else {
          // Si no hay selector de idioma específico, usar el footer completo
          const footerBottom = footerRect.bottom;

          // Si el footer está en la zona del sticky bar
          if (footerBottom >= stickyBarTop && footerRect.top <= stickyBarBottom) {
            shouldHide = true;
          }
        }

        // Aplicar ocultamiento completo si debe hacerlo
        if (shouldHide) {
          bar.classList.add('is-fading');
          bar.style.opacity = '0';
          bar.style.pointerEvents = 'none';
        } else {
          bar.classList.remove('is-fading');
          bar.style.opacity = '';
          bar.style.pointerEvents = '';
        }
      }

      function setupObserver() {
        const observeTarget = mainAtcButton || productInfoBuy;
        if (!observeTarget) return;

        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                show();
                // Verificar colisión con footer después de mostrar
                requestAnimationFrame(checkFooterCollision);
              } else {
                hide();
              }
            });
          },
          { threshold: 0, rootMargin: '0px 0px -80px 0px' }
        );

        observer.observe(observeTarget);

        // Agregar listener de scroll para verificar colisión con footer
        let scrollTimeout;
        window.addEventListener(
          'scroll',
          () => {
            if (scrollTimeout) {
              cancelAnimationFrame(scrollTimeout);
            }
            scrollTimeout = requestAnimationFrame(checkFooterCollision);
          },
          { passive: true }
        );
      }

      function setupPriceObserver() {
        if (!priceSource || !priceTarget) return;
        if (priceObserver) priceObserver.disconnect();
        priceObserver = new MutationObserver(() => syncPrice());
        priceObserver.observe(priceSource, { childList: true, subtree: true, characterData: true });
      }

      syncPrice();
      syncSelectionsFromPdp();
      syncAtcState();
      bindUi();
      setupObserver();
      setupPriceObserver();

      mq.addEventListener('change', (ev) => {
        if (!ev.matches) {
          hide();
          if (observer) observer.disconnect();
          if (priceObserver) priceObserver.disconnect();
          initialized = false;
        } else {
          initDesktop();
        }
      });
    }

    initDesktop();
    if (!mq.matches) {
      mq.addEventListener('change', () => initDesktop());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
